export default __webpack_public_path__ + "static/media/kitchen4-afterA-2048w.0c07ffac.png";